// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import FloatingInputController from "./floating_input_controller";
application.register("floating-input", FloatingInputController);

import AutomationFormController from "./automation_form_controller";
application.register("automation-form", AutomationFormController);

import AutomationReorderController from "./automation_reorder_controller";
application.register("automation-reorder", AutomationReorderController);

import CopyController from "./copy_controller";
application.register("copy", CopyController);

import PasswordToggleController from "./password_toggle_controller";
application.register("password-toggle", PasswordToggleController);

import PlanFormController from "./plan_form_controller";
application.register("plan-form", PlanFormController);

import MigrationFormController from "./migration_form_controller";
application.register("migration-form", MigrationFormController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);

import StripeSyncPollController from "./stripe_sync_poll_controller";
application.register("stripe-sync-poll", StripeSyncPollController);

import ProvisionProgressController from "./provision_progress_controller";
application.register("provision-progress", ProvisionProgressController);

import NestedFieldsController from "./nested_fields_controller";
application.register("nested-fields", NestedFieldsController);

import PageEditorController from "./page_editor_controller";
application.register("page-editor", PageEditorController);
import QuizEditorController from "./quiz_editor_controller";
application.register("quiz-editor", QuizEditorController);
import RichFieldController from "./rich_field_controller";
application.register("rich-field", RichFieldController);

import NavEditorController from "./nav_editor_controller";
application.register("nav-editor", NavEditorController);

import ImagePickerController from "./image_picker_controller";
application.register("image-picker", ImagePickerController);

import PlanRollupController from "./plan_rollup_controller";
application.register("plan-rollup", PlanRollupController);


import PlanAccessController from "./plan_access_controller";
application.register("plan-access", PlanAccessController);

import PlanAccessSelectController from "./plan_access_select_controller";
application.register("plan-access-select", PlanAccessSelectController);

import PostTypeFormController from "./post_type_form_controller";
application.register("post-type-form", PostTypeFormController);

import CommunityComposerController from "./community_composer_controller";
application.register("community-composer", CommunityComposerController);

import CommunityComposerModalController from "./community_composer_modal_controller";
application.register("community-composer-modal", CommunityComposerModalController);

import ComposerController from "./composer_controller";
application.register("composer", ComposerController);

import MessagesStreamController from "./messages_stream_controller";
application.register("messages-stream", MessagesStreamController);

import ThreadScrollController from "./thread_scroll_controller";
application.register("thread-scroll", ThreadScrollController);

import MemberPickerController from "./member_picker_controller";
application.register("member-picker", MemberPickerController);

import CurrencyController from "./currency_controller";
application.register("currency", CurrencyController);

import MoneyInputController from "./money_input_controller";
application.register("money-input", MoneyInputController);

import NestedFormController from "./nested_form_controller";
application.register("nested-form", NestedFormController);

import DayCheckboxController from "./day_checkbox_controller";
application.register("day-checkbox", DayCheckboxController);

import TimeslotScheduleController from "./timeslot_schedule_controller";
application.register("timeslot-schedule", TimeslotScheduleController);

import MobileNavController from "./mobile_nav_controller";
application.register("mobile-nav", MobileNavController);

import DrawerController from "./drawer_controller";
application.register("drawer", DrawerController);

import DrawerOpenerController from "./drawer_opener_controller";
application.register("drawer-opener", DrawerOpenerController);

import MembershipFormController from "./membership_form_controller";
application.register("membership-form", MembershipFormController);

import AutocompleteController from "./autocomplete_controller";
application.register("autocomplete", AutocompleteController);

import PaymentMethodFormController from "./payment_method_form_controller";
application.register("payment-method-form", PaymentMethodFormController);

import PauseFormController from "./pause_form_controller";
application.register("pause-form", PauseFormController);

import RefundFormController from "./refund_form_controller";
application.register("refund-form", RefundFormController);

import CancelFormController from "./cancel_form_controller";
application.register("cancel-form", CancelFormController);

import CreditAdjustController from "./credit_adjust_controller";
application.register("credit-adjust", CreditAdjustController);

import StaffSwitchTriggerController from "./staff_switch_trigger_controller";
application.register("staff-switch-trigger", StaffSwitchTriggerController);

import StaffSwitchModalController from "./staff_switch_modal_controller";
application.register("staff-switch-modal", StaffSwitchModalController);

import PinEntryController from "./pin_entry_controller";
application.register("pin-entry", PinEntryController);

import FormsComboboxController from "./forms/combobox_controller";
application.register("forms--combobox", FormsComboboxController);

import KioskPinController from "./kiosk_pin_controller";
application.register("kiosk-pin", KioskPinController);

import KioskSearchController from "./kiosk_search_controller";
application.register("kiosk-search", KioskSearchController);

import KioskEnterModalController from "./kiosk_enter_modal_controller";
application.register("kiosk-enter-modal", KioskEnterModalController);

import KioskEnterTriggerController from "./kiosk_enter_trigger_controller";
application.register("kiosk-enter-trigger", KioskEnterTriggerController);

import KioskExitPinController from "./kiosk_exit_pin_controller";
application.register("kiosk-exit-pin", KioskExitPinController);

import KioskClassSelectController from "./kiosk_class_select_controller";
application.register("kiosk-class-select", KioskClassSelectController);

import KioskConfirmationController from "./kiosk_confirmation_controller";
application.register("kiosk-confirmation", KioskConfirmationController);

import KioskAutoReturnController from "./kiosk_auto_return_controller";
application.register("kiosk-auto-return", KioskAutoReturnController);

import MergeTagsController from "./merge_tags_controller";
application.register("merge-tags", MergeTagsController);

import AgreementTypeCardsController from "./agreement_type_cards_controller";
application.register("agreement-type-cards", AgreementTypeCardsController);

import AssignAgreementController from "./assign_agreement_controller";
application.register("assign-agreement", AssignAgreementController);

import SignaturePadController from "./signature_pad_controller";
application.register("signature-pad", SignaturePadController);

import DropdownEscapeOverflowController from "./dropdown_escape_overflow_controller";
application.register("dropdown-escape-overflow", DropdownEscapeOverflowController);

import PipelineController from "./pipeline_controller";
application.register("pipeline", PipelineController);

import PipelineHighlightController from "./pipeline_highlight_controller";
import PipelineMobileStageController from "./pipeline_mobile_stage_controller";
application.register("pipeline-highlight", PipelineHighlightController);
application.register("pipeline-mobile-stage", PipelineMobileStageController);

import LeadFormController from "./lead_form_controller";
application.register("lead-form", LeadFormController);

import RevenuePaceTimelineController from "./revenue_pace_timeline_controller";
application.register("revenue-pace-timeline", RevenuePaceTimelineController);

import RevenueGoalLinkController from "./revenue_goal_link_controller";
application.register("revenue-goal-link", RevenueGoalLinkController);

import AcquisitionEstimatorController from "./acquisition_estimator_controller";
application.register("acquisition-estimator", AcquisitionEstimatorController);

import RecurringPotentialController from "./recurring_potential_controller";
application.register("recurring-potential", RecurringPotentialController);

import DiscountLeakageRealignController from "./discount_leakage_realign_controller";
application.register("discount-leakage-realign", DiscountLeakageRealignController);

import FormAutoSubmitController from "./form_auto_submit_controller";
application.register("form-auto-submit", FormAutoSubmitController);

import RevenueGoalFormController from "./revenue_goal_form_controller";
application.register("revenue-goal-form", RevenueGoalFormController);

import RankSortableController from "./rank_sortable_controller";
application.register("rank-sortable", RankSortableController);

import RankColorSelectorController from "./rank_color_selector_controller";
application.register("rank-color-selector", RankColorSelectorController);

import ColorSyncController from "./color_sync_controller";
application.register("color-sync", ColorSyncController);

import PreviewDeviceController from "./preview_device_controller";
application.register("preview-device", PreviewDeviceController);

import FunnelStepReorderController from "./funnel_step_reorder_controller";
application.register("funnel-step-reorder", FunnelStepReorderController);

import FunnelWizardController from "./funnel_wizard_controller";
application.register("funnel-wizard", FunnelWizardController);

import PreviewScrollController from "./preview_scroll_controller";
application.register("preview-scroll", PreviewScrollController);

import RankGroupProgramsController from "./rank_group_programs_controller";
application.register("rank-group-programs", RankGroupProgramsController);

import AssignRankController from "./assign_rank_controller";
application.register("assign-rank", AssignRankController);

import CsvMappingPreviewController from "./csv_mapping_preview_controller";
application.register("csv-mapping-preview", CsvMappingPreviewController);

import TimestampInterpretationController from "./timestamp_interpretation_controller";
application.register("timestamp-interpretation", TimestampInterpretationController);

import ImportTypeFormController from "./import_type_form_controller";
application.register("import-type-form", ImportTypeFormController);

import MemberUploadPanelController from "./member_upload_panel_controller";
application.register("member-upload-panel", MemberUploadPanelController);

import BulkAssignStatusController from "./bulk_assign_status_controller";
application.register("bulk-assign-status", BulkAssignStatusController);

import BulkReviewActionsController from "./bulk_review_actions_controller";
application.register("bulk-review-actions", BulkReviewActionsController);

import UploadDropzoneController from "./upload_dropzone_controller";
application.register("upload-dropzone", UploadDropzoneController);

import DestroyConfirmController from "./destroy_confirm_controller";
application.register("destroy-confirm", DestroyConfirmController);

import ConfirmController from "./confirm_controller";
application.register("confirm", ConfirmController);

import CampaignConfirmController from "./campaign_confirm_controller";
application.register("campaign-confirm", CampaignConfirmController);

import TimezoneController from "./timezone_controller";
application.register("timezone", TimezoneController);

import StagedActivityCandidateController from "./staged_activity_candidate_controller";
application.register("staged-activity-candidate", StagedActivityCandidateController);

import StagedMemberSuggestionController from "./staged_member_suggestion_controller";
application.register("staged-member-suggestion", StagedMemberSuggestionController);

import BulkMatchPreviewController from "./bulk_match_preview_controller";
application.register("bulk-match-preview", BulkMatchPreviewController);

import ActivityClassMappingController from "./activity_class_mapping_controller";
application.register("activity-class-mapping", ActivityClassMappingController);

import BulkPlanSelectionController from "./bulk_plan_selection_controller";
application.register("bulk-plan-selection", BulkPlanSelectionController);

import CalendarCurrentTimeController from "./calendar_current_time_controller";
import CalendarScrollController from "./calendar_scroll_controller";
import CalendarWeekNavController from "./calendar_week_nav_controller";
import CalendarWeekTransitionController from "./calendar_week_transition_controller";
application.register("calendar-current-time", CalendarCurrentTimeController);
application.register("calendar-scroll", CalendarScrollController);
application.register("calendar-week-nav", CalendarWeekNavController);
application.register("calendar-week-transition", CalendarWeekTransitionController);

import AttendancePieChartController from "./attendance_pie_chart_controller";
application.register("attendance-pie-chart", AttendancePieChartController);

import MarketingHeaderController from "./marketing_header_controller";
application.register("marketing-header", MarketingHeaderController);

import ReferralCopyController from "./referral_copy_controller";
application.register("referral-copy", ReferralCopyController);

import TextRotateController from "./text_rotate_controller";
application.register("text-rotate", TextRotateController);

import MarketingReportingTabsController from "./marketing_reporting_tabs_controller";
application.register("marketing-reporting-tabs", MarketingReportingTabsController);

import GrowthCalculatorWizardController from "./growth_calculator_wizard_controller";
application.register("growth-calculator-wizard", GrowthCalculatorWizardController);

import GrowthResultController from "./growth_result_controller";
application.register("growth-result", GrowthResultController);

import ChurnCalculatorController from "./churn_calculator_controller";
application.register("churn-calculator", ChurnCalculatorController);

import AppPreviewController from "./app_preview_controller";
application.register("app-preview", AppPreviewController);

import WaitlistModalController from "./waitlist_modal_controller";
application.register("waitlist-modal", WaitlistModalController);

import ScrollRevealController from "./scroll_reveal_controller";
application.register("scroll-reveal", ScrollRevealController);

import GlossaryFilterController from "./glossary_filter_controller";
application.register("glossary-filter", GlossaryFilterController);

import WaiverFulfillmentController from "./waiver_fulfillment_controller";
application.register("waiver-fulfillment", WaiverFulfillmentController);

import WebhookEventsController from "./webhook_events_controller";
application.register("webhook-events", WebhookEventsController);

import CalendarAppointmentController from "./calendar_appointment_controller";
application.register("calendar-appointment", CalendarAppointmentController);

import AppointmentBookingController from "./appointment_booking_controller";
application.register("appointment-booking", AppointmentBookingController);

import AppointmentSchedulingFormController from "./appointment_scheduling_form_controller";
application.register("appointment-scheduling-form", AppointmentSchedulingFormController);

import AppointmentDraggableController from "./appointment_draggable_controller";
application.register("appointment-draggable", AppointmentDraggableController);

import AppointmentDropZoneController from "./appointment_drop_zone_controller";
application.register("appointment-drop-zone", AppointmentDropZoneController);

import AvailabilityBuilderController from "./availability_builder_controller";
application.register("availability-builder", AvailabilityBuilderController);

import SpotGridController from "./spot_grid_controller";
application.register("spot-grid", SpotGridController);

import SpotAssignController from "./spot_assign_controller";
application.register("spot-assign", SpotAssignController);

import MetricChartController from "./metric_chart_controller";
application.register("metric-chart", MetricChartController);

import ChallengeDatesController from "./challenge_dates_controller";
application.register("challenge-dates", ChallengeDatesController);

import PromotionSelectController from "./promotion_select_controller";
application.register("promotion-select", PromotionSelectController);

import OnboardingRepeaterController from "./onboarding_repeater_controller";
application.register("onboarding-repeater", OnboardingRepeaterController);

import CheckboxListController from "./checkbox_list_controller";
application.register("checkbox-list", CheckboxListController);

import OscarConsoleController from "./oscar_console_controller";
application.register("oscar-console", OscarConsoleController);

import SortableListController from "./sortable_list_controller";
application.register("sortable-list", SortableListController);

import OscarVoiceConsoleController from "./oscar_voice_console_controller";
application.register("oscar-voice-console", OscarVoiceConsoleController);

import GuardianPickerController from "./guardian_picker_controller";
application.register("guardian-picker", GuardianPickerController);

import DisclosureController from "./disclosure_controller";
application.register("disclosure", DisclosureController);

import ResponsibilityPickerController from "./responsibility_picker_controller";
application.register("responsibility-picker", ResponsibilityPickerController);

import MigrationAssistanceController from "./migration_assistance_controller";
application.register("migration-assistance", MigrationAssistanceController);

import BannerOffsetController from "./banner_offset_controller";
application.register("banner-offset", BannerOffsetController);

import TagSelectController from "./tag_select_controller";
application.register("tag-select", TagSelectController);

import ScorecardController from "./scorecard_controller";
application.register("scorecard", ScorecardController);

import BulkPlanMappingController from "./bulk_plan_mapping_controller";
application.register("bulk-plan-mapping", BulkPlanMappingController);

import WebsiteBuilderPreviewController from "./website_builder_preview_controller";
application.register("website-builder-preview", WebsiteBuilderPreviewController);

import AutoLockController from "./auto_lock_controller";
application.register("auto-lock", AutoLockController);

import SiteGeneratorController from "./site_generator_controller";
application.register("site-generator", SiteGeneratorController);

import SiteWizardController from "./site_wizard_controller";
application.register("site-wizard", SiteWizardController);

import OscarRefineController from "./oscar_refine_controller";
application.register("oscar-refine", OscarRefineController);

import OscarBlockController from "./oscar_block_controller";
application.register("oscar-block", OscarBlockController);

import "./railsui";
